import SectionCard from '@/components/MedicalLocation/SectionCard';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { LOCATION_CUSTOMS, LOCATION_CUSTOMS_DETAIL } from '@repo/constants';
import React, { useState } from 'react';
import styled from 'styled-components';

const LocationCustoms = () => {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;
  const [selectLocation, setSelectLocation] = useState<
    'incheonT1' | 'incheonT2' | 'gimpo' | 'gimhae' | 'jeju'
  >('incheonT1');

  return (
    <ReceiptLayout>
      <Title>{nationality === 'KOR' ? '세관 위치' : 'Customs Location'}</Title>
      <BadgeWrapper>
        {LOCATION_CUSTOMS.map(({ name, engName, key }) => (
          <li key={key}>
            <Badge
              type='button'
              onClick={() => setSelectLocation(key)}
              isSelected={key === selectLocation}
            >
              {nationality === 'KOR' ? name : engName}
            </Badge>
          </li>
        ))}
      </BadgeWrapper>
      <LocationWrapper>
        {LOCATION_CUSTOMS_DETAIL[selectLocation].map((printData, index) => {
          return (
            <li key={index}>
              <SectionCard
                type={printData.type}
                location={printData.location}
                time={printData.time}
                tel={printData.tel}
                imgSrc={printData.img}
                mapSrc={printData.map}
              />
            </li>
          );
        })}
      </LocationWrapper>
    </ReceiptLayout>
  );
};

export default LocationCustoms;

const Title = styled.strong`
  display: block;
  width: 100%;
  margin-top: 20px;
  color: #3a3b3e;
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

const BadgeWrapper = styled.ul`
  display: flex;
  gap: 6px;
  width: 100%;
  margin: 16px auto 20px;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Badge = styled.button<{ isSelected: boolean }>`
  padding: 6px 16px;
  border-radius: 6px;
  background: ${({ isSelected }) => (isSelected ? '#3a3b3e' : '#F5F6F7')};
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#A7A7A7')};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
  white-space: nowrap;
`;

const LocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0 100px;
  list-style: none;
`;

const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
`;
